import { useEffect } from "react";
import Lenis from "lenis";

// Module-level singleton so <ScrollToTop> and other callers can reach the
// running Lenis instance without prop-drilling or a context.
let _lenis = null;
export function getLenis() {
  return _lenis;
}

// Global momentum smooth-scroll — signature editorial feel.
// Disabled inside iframes (previews) or on touch to preserve native gesture.
export default function SmoothScroll() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const isTouch = window.matchMedia?.("(pointer: coarse)").matches;
    if (isTouch) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.2,
    });
    _lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // Route hash scroll through Lenis for smooth in-page anchors.
    const onHashClick = (e) => {
      const a = e.target.closest?.("a[href^='#']");
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || href === "#") return;
      const id = href.slice(1);
      const el = document.getElementById(id) || document.querySelector(href);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80, duration: 1.4 });
      }
    };
    document.addEventListener("click", onHashClick);

    return () => {
      document.removeEventListener("click", onHashClick);
      cancelAnimationFrame(rafId);
      lenis.destroy();
      _lenis = null;
    };
  }, []);

  return null;
}
